import { render, staticRenderFns } from "./VerifyEmailSignup.vue?vue&type=template&id=33709f97&"
import script from "./VerifyEmailSignup.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports